module.exports = fox._r("css/slick/fonts/slick.eot", __webpack_public_path__ + "_/_/_/main/css/slick/fonts/1hzQMgk.eot");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/main/css/slick/fonts/slick.eot
// module id = 42
// module chunks = 4